import type { TestId } from '@repo/test-id';

import { useCountdownTimer } from '@features/reservation/hooks/useCountdownTimer';

interface Props {
  remainingSeconds: number;
  onExpire: () => void;
  testId: TestId;
}

export default function ProcessCountdown({ remainingSeconds, onExpire, testId }: Props) {
  const { formattedTime } = useCountdownTimer({
    initialSeconds: remainingSeconds,
    onExpire,
  });

  return (
    <span className="text-heading text-base font-normal tabular-nums" data-testid={testId}>
      {formattedTime}
    </span>
  );
}
